import React, { useMemo } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import Container from "@material-ui/core/Container";
import AppBar from "../../Components/AppBar";
import { useLocation } from "react-router";
import ResetPassword from "../../../Components/ResetPassword";
import Level2BoxContainer from "../../../Components/FrontPage/Level2BoxContainer";

export default () => {
  console.log("Route");
  const location = useLocation();
  const code = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("resetcode");
  }, [location]);

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Reset password</Trans>
      </PageHeader>

      <Container maxWidth="xs">
        <Level2BoxContainer>
          <ResetPassword code={code} />
        </Level2BoxContainer>
      </Container>
    </MobilePage>
  );
};
